/*
 * @Author: Your name
 * @Date:   2020-06-28 18:34:48
 * @Last Modified by: wxm
 * @Last Modified time: 2021-12-03 14:35:17
 */
/* jshint esversion: 6 */
export default {
  state: {
    // 应用名称
    appName: 'mob-AIQ',
    token:''

  },
  getters: {},
  mutations: {
    setToken (state, token){
      state.token = token
      localStorage.setItem('token', token);
    },
    delToken (state){
      state.token = ''
      localStorage.removeItem('token')
    },
    changeToken (state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    }
  },
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/App.js